import React, { useCallback, useRef, useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { DarkButton } from '../../ui/StyledComponents'

export default function ConfirmDialog({ open, title, message, confirmText = 'Sí', cancelText = 'No', onConfirm, onCancel }) {
    return (
        <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>{message}</DialogContent>
            <DialogActions>
                <Button onClick={onCancel}>{cancelText}</Button>
                <DarkButton onClick={onConfirm} autoFocus>{confirmText}</DarkButton>
            </DialogActions>
        </Dialog>
    )
}

// const [confirm, confirmDialog] = useConfirm()
// if (await confirm({ title, message })) { ... }   — renderizar {confirmDialog} en el componente
export function useConfirm() {
    const [options, setOptions] = useState(null)
    const resolveRef = useRef(null)

    const confirm = useCallback((opts) => new Promise((resolve) => {
        resolveRef.current = resolve
        setOptions(opts)
    }), [])

    const close = (result) => {
        resolveRef.current?.(result)
        resolveRef.current = null
        setOptions(null)
    }

    const confirmDialog = (
        <ConfirmDialog
            open={!!options}
            {...options}
            onConfirm={() => close(true)}
            onCancel={() => close(false)}
        />
    )

    return [confirm, confirmDialog]
}
